import { initLegoData, legic } from '@/lib/legic'
import '@zz/sasscore/flexible.js'
import { SentryVueInit } from '@zz-common/sentry'
import native from '@zz-common/native-adapter'
import { setPicSize, cookie } from '@zz-common/zz-utils'
import VueLazyLaod from 'vue-lazyload'
import plugins from '@/lib/plugins'
import Directive from '@/lib/directive'
import VARS from '@/lib/vars'
import URL from '@/lib/url'
import Vue from 'vue'
import VueBus from 'vue-bus'
import App from './App.vue'
import router from './route/index'
import { setCookie, getCookie } from '@/lib/cookie'
import enterPage from '@/lib/enterPage.js'
import { legoInitWrap } from './lego'
import { lego } from '@zz-common/lego'
import { dateFormat, token } from '@/lib/util'
import logStore from './views/test/logStore'
import { Toast, Lottie } from '@zz-common/zz-ui'
import VueCompositionApi from '@vue/composition-api'

const isUnifiedUrl = (url) => [/^zz:/, /^zzseller:/, /^zzcheck:/].some((i) => i.test(url))

Vue.config.productionTip = false
initLegoData()
// console.log('打印', window.collectEvent)
// 火山无法在预渲染页面中使用，在重定向时，无法监听到，无法继续上报埋点，所以测试只在小程序端测试
if (location.href.indexOf('/zz-platform-pages/history') > -1 && window.collectEvent && cookie.get('t') === '103') {
  // otherIOInit('huoshan')
  window.collectEvent('init', {
    app_id: 20002025, // 参考2.1节获取，注意类型是number而非字符串
    channel_domain: 'https://gator.volces.com',
    disable_sdk_monitor: true, //用于禁止SDK启动后自身监控事件 onload 的上报
    // channel: 'cn', // 设置数据上送地址
    enable_stay_duration: true,
    // channel_domain: 'https://gator.volces.com',
    // track_attr: ['area', 'goods'],
    autotrack: {
      track_attr: ['data-exposure'],
      exposure: {
        radio: 0.5 // 元素曝光比例，0-1，默认0.5，即元素展示面积超过50%时曝光
        // eventName: '' //可以自定义上报的曝光事件名，默认是bav2b_exposure
      }
    } // 全埋点开关，true开启，false关闭
    // allow_hash: true,
    // spa: true,
    // log: true, // true:开启日志，false:关闭日志
    // enable_debug: true
  });
  window.collectEvent('config', {
    user_unique_id: token,
    tk: token,
    t: cookie.get('t') || cookie.get('zz_t')
  });
  window.collectEvent('profileSet', {
    tk: token,
    t: cookie.get('t') || cookie.get('zz_t')
  })
  // 此处可添加设置uuid、设置公共属性等代码
  window.collectEvent('start'); // 通知SDK设置完毕，可以真正开始发送事件了
  window.collectEvent('test-afterImport');
  lego.send({
    actiontype: 'V4961',
    pagetype: 'test-afterImport'
  })
}

// 我理解下边只是在cookie中种channel
;(function channelSet() {
  const cookieKey = 'h5checkin_channel'
  // 获取指定channel
  let channel =
    URL.getParam('channel') ||
    URL.getParam('channelid') ||
    getCookie(cookieKey) ||
    'h5checkin_zzapp'
  // channel处理
  if (channel) {
    // 转换成小写
    channel = channel.toLowerCase()
    // 加入业务线前缀
    channel = channel.indexOf(VARS.legoPrefix) === -1 ? VARS.legoPrefix + channel : channel
    // 与本地cookie比对，不一致，进行更新
    if (VARS.channel !== channel) {
      VARS.channel = channel
      // 设置本地cookie
      setCookie(cookieKey, VARS.channel, { expires: 1 })
    }
  }
  // 设置t值1
  VARS.t = URL.getParam('__t') || getCookie('t') || ''
})()

Vue.prototype.$legic = legic
Vue.prototype.$setPicSize = setPicSize
Vue.prototype.$enterPage = enterPage
Vue.prototype.$toast = Toast
Vue.prototype.$getCookie = getCookie
Vue.use(VueCompositionApi)
Vue.use(Lottie)

const __PAGE_META_ = (window as any)?.__PAGE_META__
const isTesting = __PAGE_META_?.env === 'testing' && !__PAGE_META_?.isSandbox
const isSandbox = __PAGE_META_?.env === 'testing' && __PAGE_META_?.isSandbox

class __App__ {
  public init() {
    // 加载自定义 directive
    Vue.use(Directive)
    Vue.use(VueBus)
    // 通用插件
    Vue.use(plugins)

    window.addEventListener('legoLog', (event: any) => {
      const { typeDesc = '', actionType = '', pageType = '' } = event.detail
      if (typeDesc && actionType && pageType) {
        logStore.unshift(
          Object.assign({}, event.detail, {
            time: dateFormat(Date.now(), 'YYYY-MM-dd hh:mm:ss')
          })
        )
      }
    })

    if (process.env.NODE_ENV !== 'development' && !isTesting && !isSandbox) {
      // 错误监控平台
      this.useSentry()
    }

    if (process.env.NODE_ENV !== 'production') {
      // const script = document.createElement('script');
      // // 设置 <script> 元素的 src 属性为外部脚本文件的 URL
      // script.src = 'https://s1.zhuanstatic.com/common/biz/js/dev-tool.js';
      // // 将 <script> 元素插入到文档的 <head> 元素中
      // document.head.appendChild(script);
    }

    this.useFilter()
    // 懒加载
    this.sueLazyLaod()
    this.setGo()
    router.afterEach(() => {
      legoInitWrap()
    })
    // 注册vue实例
    this.mount()
  }

  public mount() {
    new Vue({
      router,
      render: (h) => h(App)
    }).$mount('#app')
  }

  public useFilter() {
    tryCatch(function () {
      require('@/utils/filters.ts')
    })
  }

  public useSentry() {
    tryCatch(function () {
      if (process.env.NODE_ENV === 'production') {
        // SentryVueInit(
        //   'https://07fc76f9fd084a4282f87f6708a9cf39@sentry.zhuanspirit.com/1372',
        //   {
        //     // senddev: true
        //     ignoreErrors: [
        //       /Unexpected identifier/, //客户端 ios webview错误
        //       /c35 is not defined/, //需升级adapter
        //       /Could not load image at GuoLv/g,
        //       /sentryGuoLv321/g,
        //       '请先登录哦~'
        //     ]
        //   },
        //   {
        //     injectRRWeb: true
        //   }
        // )
        SentryVueInit()
        // throw new Error()
        // Raven.config(
        //   'https://07fc76f9fd084a4282f87f6708a9cf39@sentry.zhuanspirit.com/1372',
        //   {
        //     // 环境变量
        //     environment: process.env.NODE_ENV,
        //     // 只有 production 环境才上报错误
        //     autoBreadcrumbs: process.env.NODE_ENV === 'production',
        //     // 忽略上报错误（支持正则）
        //     ignoreErrors: [
        //       /webpack/gi,
        //       /^Error: Network Error$/g,
        //       'Error: Timeout',
        //       'ReferenceError: WeixinJSBridge is not defined'
        //     ],
        //     // 忽略上报名单 URL，忽略上报当前名单 URL 错误（支持正则）
        //     ignoreUrls: [/webpack/gi]
        //   }
        // )
        //   .addPlugin(RavenVue, Vue)
        //   .install()
      }
    })
  }

  public sueLazyLaod() {
    tryCatch(function () {
      Vue.use(VueLazyLaod, {
        preLoad: 1.3,
        try: 2,
        filter: {
          setSize(listener, options) {
            const isCDN = /zhuanstatic.com/
            if (isCDN.test(listener.src)) {
              /* 根据不同dpr设置不同尺寸 */
              const devicePixelRatio = window.devicePixelRatio
              const { offsetWidth } = listener.el
              /* 根据宽度自动设置尺寸，但仅设置宽度，这是为了某些高度不定的图片不会产生拉伸，例如未设定高度的img标签 */
              listener.src = setPicSize(listener.src, offsetWidth * devicePixelRatio)
              /* 当启用webp时，设置t=5 */
              if (options.supportWebp) {
                listener.src += '&t=5'
              }
            }
          }
        }
      })
    })
  }

  setGo() {
    /**
     * 通用的组件内跳转url方法，会开启一个新的webview
     * @author wangsongyan@zhuanzhuan.com
     * @anotherdate 2019-09-03T11:08:01+0800
     * @param       {string}                 url       要跳转的url,支持统跳协议
     * @param       {string}                 logAction 点击埋点的actiontype
     * @param       {object}                 logBackup 点击埋点的backup字段
     * @return      {null}                           空
     */
    Vue.prototype.$go = function (url, logAction, logBackup) {
      this.$log && this.$log(logAction, logBackup)
      return isUnifiedUrl(url)
        ? native.wrap('enterUnifiedUrl')({ unifiedUrl: url })
        : native.skipToUrl({ targetUrl: url })
    }
  }
}

const app = new __App__()
app.init()

// if (process.env.NODE_ENV !== 'development' && !isTesting && !isSandbox) {
//   Vue.config.errorHandler = (err) => {
//     SentryCapture(err, 'error')
//   }
// }

function tryCatch(fn) {
  try {
    fn()
  } catch (err) {
    console.error(err)
  }
}
